import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import Icon, { GLYPHS } from '../../../common/icon';

const PromoCode = ({ onSubmit, value, onChange, disabled, placeholder, appliedPromoCode, resetPromoCode }) => (
  <form onSubmit={onSubmit}>
    <div className="c-label-new">{t('register:payment.promo_code.label')}</div>
    <div className="o-flexbox">
      <div className="u-flex-1 u-position-relative u-pr-">
        <div className="c-prefix">
          <Icon className="c-prefix__icon" glyph={GLYPHS.discount} />
        </div>
        <input
          className="c-input c-input--white u-height-40 c-input--prepend u-flex-1 u-pl+"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          data-automation-id="input:promoCode"
        />
        <button
          type="button"
          className="c-btn c-btn--blank u-inline-block u-pin-right u-mr"
          onClick={resetPromoCode}
          display-if={appliedPromoCode}
        >
          <Icon glyph={GLYPHS.arrowXClose} />
        </button>
      </div>

      <button
        type="submit"
        className="c-btn c-btn--medium"
        disabled={disabled}
        data-automation-id="button:addPromoCode"
      >
        {t('register:payment.promo_code.add_button')}
      </button>
    </div>
  </form>
);
PromoCode.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired,
  appliedPromoCode: PropTypes.string.isRequired,
  resetPromoCode: PropTypes.func.isRequired,
};

export default PromoCode;
